import * as Yup from 'yup';

export const POST_TITLE_MAX_LENGTH = 100;

const hasTextContent = (value?: string) => {
	if (!value) return false;

	const element = document.createElement('div');
	element.innerHTML = value;
	return element.innerText.trim().length > 0;
};

export const postUpsertValidationSchema = Yup.object().shape({
	title: Yup.string()
		.required('Title is required')
		.max(POST_TITLE_MAX_LENGTH, `Maximum length is ${POST_TITLE_MAX_LENGTH} characters`),
	description: Yup.string()
		.required('Description is required')
		.test('has-text', 'Description is required', value => hasTextContent(value)),
	isVirtual: Yup.boolean().required(),
	address: Yup.mixed().when('isVirtual', {
		is: false,
		then: Yup.object().required('Location is required'),
		otherwise: Yup.mixed().nullable(true),
	}),
});
